module.exports = __webpack_public_path__ + "img/miryoku_c2.bfeecaac.png";